import * as Yup from "yup";

export const AttributeTypeBindSchema = Yup.object().shape({
    type_id: Yup.number().nullable().required("Пожалуйста, укажите тип атрибута"),
    attribute_type_name: Yup.string().required("Пожалуйста, укажите название"),
});
